module.exports = __webpack_public_path__ + "static/media/trust.1e94d8f0.png";